import {Stack} from "@mui/material";
import React from "react";
import {useTranslation} from "react-i18next";
import {
    InlineInput,
    InlineLabelledField,
    localizedValue,
    patchLocalized,
    QuestionEditorProps
} from "./questionEditor.types";

const ButtonLabelQuestionEditor = (props: QuestionEditorProps) => {
    const {t} = useTranslation();
    const {question, language, disabled} = props;

    return (
        <Stack gap={1.5}>
            <InlineLabelledField label={t('Button label')}>
                <InlineInput
                    value={localizedValue(question.buttonLabel, language)}
                    onChange={value => patchLocalized(props, 'buttonLabel', value)}
                    disabled={disabled}
                />
            </InlineLabelledField>
        </Stack>
    );
};

export default ButtonLabelQuestionEditor;
